import React from 'react';
import PropTypes from 'prop-types';
import { TableBody} from '@mui/material';
import { sequence } from '@totalsoft/change-tracking-react';
import FinancialProductDetailsInsurersTableRow from './FinancialProductInsurersTableRow';

const FinancialProductDetailsInsurersTableBody = ({ 
  canWrite, 
  onCancelEdit,
  onDelete,
  onSave,
  productInsurerList,  
  insurersList,
  insuranceTypeList,
  conventionList,
  validation
}) => {
  return (
    <TableBody>
      {sequence(productInsurerList)?.map((data, index) => {
        return (
          <FinancialProductDetailsInsurersTableRow
            canWrite={canWrite}
            key={index}
            dataLens={data}
            index={index}
            onCancelEdit={onCancelEdit}
            onDelete={onDelete}
            onSave={onSave}
            insurersList ={insurersList}
            insuranceTypeList ={insuranceTypeList}
            conventionList ={conventionList}
            validation={validation[index]}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductDetailsInsurersTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  productInsurerList: PropTypes.array.isRequired,
  insurersList: PropTypes.array.isRequired,
  insuranceTypeList: PropTypes.array.isRequired,
  conventionList: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductDetailsInsurersTableBody;
